import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { useEffect, useState } from 'react';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import ReferralPage from './pages/ReferralPage';
import ProtectedRoute from './components/ProtectedRoute';
import Adminv1 from './pages/Admin-v1';

function AppWrapper() {
  const [loggedIn, setLoggedIn] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_URL;

  // Перевірка авторизації
  useEffect(() => {
    fetch('${API_BASE}/check-auth', {
      credentials: 'include',
    })
      .then((res) => (res.ok ? res.json() : Promise.reject()))
      .then((data) => setLoggedIn(data.loggedIn))
      .catch(() => setLoggedIn(false));
  }, []);

  // Обробка реферального параметра
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get('ref');
    if (ref && location.pathname === '/') {
      navigate(`/ref?ref=${ref}`);
    }
  }, [location, navigate]);

  if (loggedIn === null) return <div>Loading...</div>;

  return (
    <Routes>
      <Route path="/login" element={<LoginPage setLoggedIn={setLoggedIn} />} />
      <Route path="/ref" element={<ReferralPage />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute loggedIn={loggedIn}>
            <AdminPage />
          </ProtectedRoute>
        }
      />
            <Route
        path="/admin-v1"
        element={
          <ProtectedRoute loggedIn={loggedIn}>
            <Adminv1 />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<ReferralPage />} />
    </Routes>
  );
}

export default function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}
